export default {"src":"/_next/static/media/sub-menu-arrow-dark.37ca0644.svg","height":7,"width":12,"blurWidth":0,"blurHeight":0};